import React,  { useState } from 'react';
import { find } from 'lodash';
import countriesByContinent from 'country-json/src/country-by-continent.json';
import MultiSelect from './MultiSelect';
import countriesByAbbreviation from '../../common/CountriesByAbbreviation';

export default function ContinentsList(props) {
	
	const { continent, selectedCountries, setSelectedCountries } = props;
	let countries = [];
	for(let country of countriesByContinent) {
		if(country.continent == continent) {
			const countryData = find(countriesByAbbreviation, c=>c.country == country.country);
			if(countryData) {
				countries.push({
					label: countryData.country,
					value: countryData.abbreviation
				})
			}
		}
	}
	

	
	return <MultiSelect 
		isMulti={true} 
		options={countries} 
		value={selectedCountries}
		onChange={setSelectedCountries}
		className="selected-countries-list"
	/>
	
}